<template>
  <div>
    <div class="flex-container">
      <div class="table">
        <div class="title">管理组意见</div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            :disabled="adviceList.length >= 1 || user.courseManager != 1"
            @click="addAdviceDialog = true"
            >意见反馈</el-button
          >
        </div>
        <el-table
          :max-height="height"
          :data="adviceList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <el-table-column
            label="操作"
            align="center"
            min-width="80px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status == 5 && scope.row.ygbh == user.ygbh"
                @click="handleChangeEditDialog(scope.row)"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="审核人"
            align="left"
            prop="xm"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="状态"
            align="left"
            prop="statusName"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="审核时间"
            align="left"
            prop="feedbackTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="备注说明"
            align="left"
            prop="content"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="adviceList.length > 0"
          :total="adviceList.length"
          :page.sync="adviceParams.page"
          :limit.sync="adviceParams.pageSize"
          @pagination="getAdviceList"
        />
      </div>
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> 课题撤销情况 </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" key="9">
            <div class="result_content">
              <div style="padding: 0 15px 15px 15px">
                <div style="color: #000; font-weight: 700">
                  一、课题基本情况：
                </div>
                <div id="wangEditor_ktcx"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="card">
        <el-row>
          <el-col :span="24" key="9">
            <div class="result_content">
              <div style="padding: 0 15px 15px 15px">
                <div style="color: #000; font-weight: 700">二、撤销原因：</div>
                <div id="wangEditor2_ktcx"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="添加审核意见"
      :visible.sync="addAdviceDialog"
      append-to-body
      :closeOnClickModal="false"
      width="900px"
    >
      <div style="display: flex">
        <span style="width: 72px; text-align: right; margin-right: 15px"
          >状态<span style="color: #ff0000">*</span>:</span
        >
        <span>
          <el-radio-group v-model="addAdviceForm.status">
            <el-radio label="4">通过</el-radio>
            <el-radio label="5">不通过</el-radio>
          </el-radio-group></span
        >
      </div>
      <div style="line-height: 44px">
        意见反馈<span style="color: #ff0000">*</span> ：
      </div>
      <el-input
        type="textarea"
        v-model="addAdviceForm.content"
        :autosize="{ minRows: 6, maxRows: 12 }"
        maxlength="3000"
        show-word-limit
        placeholder="请输入意见反馈"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAdviceDialog = false">取 消</el-button>
        <el-button type="primary" @click="addAdvice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import "moment/locale/zh-cn";
import { getCancelApply, listAllFeedback, saveFeedback } from "@/api/course.js";
import Pagination from "@/components/Pagination";

export default {
  name: "courseKtcx",
  props: ["mxParams"],
  computed: {
    ...mapGetters(["course", "user"]),
  },
  components: { Pagination },
  data() {
    return {
      cancelApplyForm: [
        {
          courseId: "",
          cancelId: null,
          courseSituation: "",
          cancelReason: "",
          step: "",
          courseName: "",
        },
      ],
      height: 300,
      feedbackId: null,
      addAdviceForm: [],
      addAdviceDialog: false,
      adviceParams: {
        page: 1,
        pageSize: 10,
      },
      adviceList: [], //中期检查情况
    };
  },

  created() {
    this.getData();
    this.getAdviceList();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor_ktcx`);
    let editor2 = new wangEditor(`#wangEditor2_ktcx`);

    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    wangEditor2_ktcx;
    // editor.disable();
    // editor2.disable();
    this.editor = editor;
    this.editor2 = editor2;

    document.querySelector(
      `#wangEditor_ktcx .w-e-text-container`
    ).style.backgroundColor = "#f3f3f3";
    document.querySelector(
      `#wangEditor_ktcx .w-e-toolbar`
    ).style.backgroundColor = "#f3f3f3";
    document.querySelector(
      `#wangEditor2_ktcx .w-e-text-container`
    ).style.backgroundColor = "#f3f3f3";
    document.querySelector(
      `#wangEditor2_ktcx .w-e-toolbar`
    ).style.backgroundColor = "#f3f3f3";
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },

    handleChangeEditDialog(row) {
      this.addAdviceForm = {
        status: row.status,
        content: row.content,
      };
      this.feedbackId = row.feedbackId;
      this.addAdviceDialog = true;
    },

    getData() {
      getCancelApply({ courseId: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          this.cancelApplyForm = res.data;
          this.editor.txt.html(this.cancelApplyForm.courseSituation);
          this.editor2.txt.html(this.cancelApplyForm.cancelReason);
        }
      });
    },

    getAdviceList() {
      const { page, pageSize } = this.adviceParams;
      const courseId = this.mxParams.id;
      listAllFeedback({ page, pageSize, courseId }).then((res) => {
        if (res.code == 0) {
          this.adviceList = res.data;
        }
      });
    },

    addAdvice() {
      if (!this.addAdviceForm.status) {
        this.$message.error("状态不能为空！");
        return;
      }
      if (!this.addAdviceForm.content) {
        this.$message.error("意见反馈不能为空！");
        return;
      }
      if (this.feedbackId) {
        saveFeedback({
          ...this.addAdviceForm,
          courseId: this.mxParams.id,
          feedbackId: this.feedbackId,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.addAdviceDialog = false;
            this.feedbackId = null;
            this.getAdviceList();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        saveFeedback({
          ...this.addAdviceForm,
          courseId: this.mxParams.id,
          linkId: this.cancelApplyForm.cancelId,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.addAdviceDialog = false;
            this.getAdviceList();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.result {
  margin-bottom: 15px;
  .result_detail {
    font-size: 14px;
    background: #f3f3f3;
    line-height: 32px;
    padding-left: 15px;
    margin: 0 15px;
    color: #666;
  }
}

.content {
  margin-bottom: 30px;
  .content_item {
    line-height: 32px;
    font-size: 14px;
    .content_title {
      font-weight: 700;
    }
    .content_text {
      background-color: #f3f3f3;
      padding: 0 15px;
      margin-right: 15px;
    }
  }
}
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
</style>